module.exports = __webpack_public_path__ + "static/media/article4-image.089cc959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article4-image.png
// module id = 361
// module chunks = 3